/**
 * Multi-Cart API Service
 *
 * API methods for fetching multi-cart data from Core Backend.
 */

import { coreAPI } from '@/lib/api/client';
import type { MultiCartResponse } from './types';

/**
 * Fetch multi-cart data for the current user
 *
 * @param userCurrency - User's preferred currency code (e.g., 'USD', 'ARS')
 * @returns Promise<MultiCartResponse> - Aggregated cart data from all merchants
 * @throws ApiError on failure
 */
export async function getMultiCart(userCurrency?: string): Promise<MultiCartResponse> {
  const searchParams = userCurrency ? `?currency=${userCurrency}` : '';
  return coreAPI.get<MultiCartResponse>(`/users/me/carts${searchParams}`);
}
